/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The template engine
 */
export const RenderTemplateRequestBodyEngine = {
  Mustache: "mustache",
} as const;
/**
 * The template engine
 */
export type RenderTemplateRequestBodyEngine = ClosedEnum<
  typeof RenderTemplateRequestBodyEngine
>;

/**
 * The kind of prompt the template is used for
 */
export const RenderTemplateRequestBodyKind = {
  Prompt: "prompt",
} as const;
/**
 * The kind of prompt the template is used for
 */
export type RenderTemplateRequestBodyKind = ClosedEnum<
  typeof RenderTemplateRequestBodyKind
>;

export type RenderTemplateRequestBody = {
  /**
   * The input data to render the template with
   */
  arguments: { [k: string]: any };
  /**
   * The template engine
   */
  engine: RenderTemplateRequestBodyEngine;
  /**
   * The kind of prompt the template is used for
   */
  kind: RenderTemplateRequestBodyKind;
  /**
   * The template content to render
   */
  prompt: string;
};

/** @internal */
export const RenderTemplateRequestBodyEngine$outboundSchema: z.ZodMiniEnum<
  typeof RenderTemplateRequestBodyEngine
> = z.enum(RenderTemplateRequestBodyEngine);

/** @internal */
export const RenderTemplateRequestBodyKind$outboundSchema: z.ZodMiniEnum<
  typeof RenderTemplateRequestBodyKind
> = z.enum(RenderTemplateRequestBodyKind);

/** @internal */
export type RenderTemplateRequestBody$Outbound = {
  arguments: { [k: string]: any };
  engine: string;
  kind: string;
  prompt: string;
};

/** @internal */
export const RenderTemplateRequestBody$outboundSchema: z.ZodMiniType<
  RenderTemplateRequestBody$Outbound,
  RenderTemplateRequestBody
> = z.object({
  arguments: z.record(z.string(), z.any()),
  engine: RenderTemplateRequestBodyEngine$outboundSchema,
  kind: RenderTemplateRequestBodyKind$outboundSchema,
  prompt: z.string(),
});

export function renderTemplateRequestBodyToJSON(
  renderTemplateRequestBody: RenderTemplateRequestBody,
): string {
  return JSON.stringify(
    RenderTemplateRequestBody$outboundSchema.parse(renderTemplateRequestBody),
  );
}
